import request from "@/utils/request";
//获取流程列表
export function getFormProcessListApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetFormProcessList`,
    method: "post",
    data,
  });
}
//获取启用流程列表
export function getEnableProcessListApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetEnableProcessList`,
    method: "post",
    data,
  });
}
//获取详细类别子类别下拉数据
export function getDetailCostTypeOptionsApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetDetailCostTypeOptions`,
    method: "post",
    data,
  });
}
//获取职工人员列表
export function getStaffListNotCurrentApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetStaffListNotCurrent`,
    method: "post",
    data,
  });
}
//获取用户岗位列表
export function getUserPostListApi(data) {
  return request({
    url: `/fmsapi/Common/GetUserPostList`,
    method: "post",
    data,
  });
}
//获取岗位人员名称
export function getUserPostUserNameApi(data) {
  return request({
    url: `/fmsapi/Common/GetUserPostUserName`,
    method: "post",
    data,
  });
}
//获取待审批列表
export function getApprovalListApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalList`,
    method: "post",
    data,
  });
}
//获取我经办和我申请审批列表
export function getMyQueryListApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetMyQueryList`,
    method: "post",
    data,
  });
}
//获取审批表单详细数据
export function getApplyFormInfoApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApplyFormInfo`,
    method: "post",
    data,
  });
}
//获取待审批详细数据
export function getApprovalDetailApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalDetail`,
    method: "post",
    data,
  });
}
//获取员工薪酬待审批明细
export function getWageCostByApprovalApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetWageCostByApproval`,
    method: "post",
    data,
  });
}
//获取费用申请明细
export function getApprovalExpenseByGuidApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalExpenseByGuid`,
    method: "post",
    data,
  });
}
//获取入职审批明细
export function getApprovalFFDetailApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalFFDetail`,
    method: "post",
    data,
  });
}
//获取离职审批明细
export function getApprovalFGDetailApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalFGDetail`,
    method: "post",
    data,
  });
}
//获取审批历史流程
export function getApprovalHistoryApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetApprovalHistory`,
    method: "post",
    data,
  });
}
//提交待审批列表
export function submitApplyFormApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/CreateApprovalForm`,
    method: "post",
    data,
  });
}
//提交加签
export function countersignFormApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/CountersignForm`,
    method: "post",
    data,
  });
}
//同意审批
export function submitAgreeFormApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/AgreeForm`,
    method: "post",
    data,
  });
}
//拒绝审批
export function submitRejectFormApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/RejectForm`,
    method: "post",
    data,
  });
}

//滴滴单点登录，获取授权链接地址
export function getLoginEncryptStr(data) {
  return request({
    url: `/fmsapi/DIDI/getLoginEncryptStr`,
    method: "post",
    data,
  });
}

//获取当前用户手机号等信息
export function GetLoginStaffUser(data) {
  return request({
    url: `/fmsapi/Common/GetLoginStaffUser`,
    method: "post",
    data,
  });
}
//获取公司层级部门数据
export function GetDepartmentNodeListApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/GetDepartmentNodeList`,
    method: "post",
    data,
  });
}
//检查报销次数限制
export function checkReimbursementFrequencyLimitApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/CheckReimbursementFrequencyLimit`,
    method: "post",
    data,
  });
}
//计算员工请假总时长
export function calculateEmployeeHolidayTimeApi(data) {
  return request({
    url: `/fmsapi/Reimbursement/CalculateEmployeeHolidayTime`,
    method: "post",
    data,
  });
}
